import React, { Component } from "react"
import PropTypes from "prop-types"
import { captureError } from "../../helpers/sentry"

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    captureError(error, { componentStack: info.componentStack })
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null })
    window.location.href = "/"
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "2rem",
            textAlign: "center",
            backgroundColor: "#f8f9fa",
          }}
        >
          <h2 style={{ color: "#343a40", marginBottom: "1rem" }}>
            Something went wrong
          </h2>
          <p style={{ color: "#6c757d", marginBottom: "1.5rem", maxWidth: 480 }}>
            An unexpected error occurred. Please try refreshing the page. If the
            problem persists, contact support.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "#556ee6",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Go to Home
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
